enum DonationType {
  Single = 'Single',
  Recurring = 'Recurring',
}
export default DonationType;
